import { useDevicesStore } from "~/stores/devicesstore";

export function useDevicesCountLoader() {
  const deviceStore = useDevicesStore();
  watch(
    () => [
      deviceStore.userDevices,
      deviceStore.companyDevices,
      deviceStore.memberDevices,
    ],
    async () => {
      await deviceStore.loadDevicesCount();
    },
  );
}
